'use client';

import { ChangeEvent, useState } from 'react';

import { useCollectionAiThumbnailMutation } from '@/entities/collection';

const useAiPrompt = () => {
  const [isPromptVisible, setIsPromptVisible] = useState(false);
  const [prompt, setPrompt] = useState('');

  const { mutate, isPending } = useCollectionAiThumbnailMutation();

  const init = () => {
    setPrompt('');
  };

  const aiSelected = () => {
    setIsPromptVisible(true);
  };

  const aiUnselected = () => {
    setIsPromptVisible(false);
  };

  const handlePromptChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    if (isPending) return;

    setPrompt(e.target.value);
  };

  return {
    init,
    mutate,
    prompt,
    setPrompt,
    isPending,
    aiSelected,
    aiUnselected,
    isPromptVisible,
    handlePromptChange,
  };
};

export default useAiPrompt;
